import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewAnswerModalContentContainer } from '../NewAnswerModalContent';
import { setNewAnswerFormClose } from '../../actions/newAnswer/openFormActions';
import { getIsLastAnswerFormStep, getIsOpen } from '../../selectors/newAnswer';
import { NewAnswerFooterContainer } from '../NewAnswer';
import { FormModalLayout } from '../../components/FormLayout';
import { useNewReplySubmitHandler } from '../../hooks/useNewReplySubmitHandler';
import { TThunkDispatch } from '../../types/redux';

export const NewAnswerModalContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const openId = useSelector(getIsOpen);
  const isLastStep = useSelector(getIsLastAnswerFormStep);

  const onSubmit = useNewReplySubmitHandler();

  const onClose = React.useCallback(() => {
    dispatch(setNewAnswerFormClose());
  }, []);

  if (!openId) {
    return null;
  }

  return (
    <FormModalLayout
      shortTitle="Ответ на отзыв"
      title="Ответ на отзыв"
      footer={<NewAnswerFooterContainer onSubmit={onSubmit} />}
      onClose={onClose}
      type={isLastStep ? 'info' : 'form'}
      open={!!openId}
      testId="NewAnswer"
    >
      <NewAnswerModalContentContainer onClose={onClose} />
    </FormModalLayout>
  );
};
